import React from 'react';
import Modal from 'components/Components/UI/Modal';
import { Link } from 'react-router-dom';
import CarouselSliderImage from 'components/Components/Includes/CarouselSliderImage';
import LinkButton from 'components/Components/UI/LinkButton';
import PropTypes from 'prop-types';

const GalleryModal = ({
    handleCloseModalGallery, element, images, selectedImageIndex, showModalGallery,
}) => (
    <Modal
        isOpen={showModalGallery}
        modalTitle="Image Gallery"
    >
        <Link
            className="modal-close-btn tw-text-gray-700 hover:tw-text-orange-400"
            to="#"
            onClick={handleCloseModalGallery}
        >
            <span className="tw-uppercase font-sp">Close</span>
            <span className="material-icons tw-align-middle tw-ml-2">close</span>
        </Link>
        <div className="tw-mt-8 md:tw-mt-16">
            <div className="arrowsAdjustments">
                <CarouselSliderImage
                    images={images}
                    element={element}
                    selectedImageIndex={selectedImageIndex}
                />
            </div>
        </div>
        <LinkButton
            text="Close"
            onClick={handleCloseModalGallery}
            link="#"
            className="tw-w-auto tw-mt-10"
            color="gray"
        />
    </Modal>
);

GalleryModal.propTypes = {
    handleCloseModalGallery: PropTypes.func.isRequired,
    element: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    selectedImageIndex: PropTypes.number.isRequired,
    showModalGallery: PropTypes.bool.isRequired,
};

export default GalleryModal;
